import React from "react";
import { Alert, Box, SpaceBetween } from "@amzn/awsui-components-react";
import { Stage } from "../../../../lusca-search-api/generated-src";

interface UsecaseDifferencesAlertProps {
  usecaseDifferences: {
    currentCount: number;
    compareCount: number;
    currentOnly: string[];
    compareOnly: string[];
    currentUsecases?: string[];
    compareUsecases?: string[];
    flowType: string;
    compareHasOtherFlowData: boolean;
    otherFlowUsecases?: string[];
    currentOnlyOtherFlowUsecases?: string[];
  };
  currentStage: Stage;
  compareStage: Stage;
}

export const UsecaseDifferencesAlert: React.FC<
  UsecaseDifferencesAlertProps
> = ({ usecaseDifferences, currentStage, compareStage }) => {
  return (
    <Alert type="info" header="Usecase differences detected">
      <SpaceBetween size="m">
        <Box>
          <Box variant="h4" margin={{ bottom: "xs" }}>
            Current Flow (
            {usecaseDifferences.flowType.charAt(0).toUpperCase() +
              usecaseDifferences.flowType.slice(1)}
            ):
          </Box>

          <Box margin={{ left: "s" }}>
            <SpaceBetween size="xs">
              <div>
                <strong>{currentStage}:</strong>{" "}
                {usecaseDifferences.currentCount} usecase
                {usecaseDifferences.currentCount !== 1 ? "s" : ""}
                {usecaseDifferences.currentUsecases &&
                  usecaseDifferences.currentUsecases.length > 0 && (
                    <span>
                      {" "}
                      (
                      {usecaseDifferences.currentUsecases.map(
                        (usecase, index) => (
                          <span key={usecase}>
                            {index > 0 && ", "}
                            {usecaseDifferences.currentOnly.includes(
                              usecase
                            ) ? (
                              <strong>{usecase}</strong>
                            ) : (
                              usecase
                            )}
                          </span>
                        )
                      )}
                      )
                    </span>
                  )}
              </div>

              <div>
                <strong>{compareStage}:</strong>{" "}
                {usecaseDifferences.compareCount} usecase
                {usecaseDifferences.compareCount !== 1 ? "s" : ""}
                {usecaseDifferences.compareUsecases &&
                  usecaseDifferences.compareUsecases.length > 0 && (
                    <span>
                      {" "}
                      (
                      {usecaseDifferences.compareUsecases.map(
                        (usecase, index) => (
                          <span key={usecase}>
                            {index > 0 && ", "}
                            {usecaseDifferences.compareOnly.includes(
                              usecase
                            ) ? (
                              <strong>{usecase}</strong>
                            ) : (
                              usecase
                            )}
                          </span>
                        )
                      )}
                      )
                    </span>
                  )}
              </div>
            </SpaceBetween>
          </Box>
        </Box>

        {((usecaseDifferences.otherFlowUsecases &&
          usecaseDifferences.otherFlowUsecases.length > 0) ||
          (usecaseDifferences.currentOnlyOtherFlowUsecases &&
            usecaseDifferences.currentOnlyOtherFlowUsecases.length > 0)) && (
          <Box>
            <Box variant="h4" margin={{ bottom: "xs" }}>
              Other Flows:
            </Box>
            <Box margin={{ left: "s" }}>
              <SpaceBetween size="xs">
                {usecaseDifferences.otherFlowUsecases &&
                  usecaseDifferences.otherFlowUsecases.length > 0 && (
                    <div>
                      <strong>{compareStage}:</strong>{" "}
                      <em>{usecaseDifferences.otherFlowUsecases.join(", ")}</em>
                    </div>
                  )}
                {usecaseDifferences.currentOnlyOtherFlowUsecases &&
                  usecaseDifferences.currentOnlyOtherFlowUsecases.length >
                    0 && (
                    <div>
                      <strong>{currentStage}:</strong>{" "}
                      <em>
                        {usecaseDifferences.currentOnlyOtherFlowUsecases.join(
                          ", "
                        )}
                      </em>
                    </div>
                  )}
              </SpaceBetween>
            </Box>
          </Box>
        )}
      </SpaceBetween>
    </Alert>
  );
};
